import { useTranslation } from 'react-i18next';
import {
  UsersIcon,
  SunIcon,
  CheckCircleIcon,
  StarIcon,
  EyeIcon,
  ShieldCheckIcon,
} from "@heroicons/react/24/outline";
import FloatingShapes from "../common/FloatingShapes";

const getTimeline = (t: any) => [
  { id: 1, content: t('about.timeline1'), href: "#", date: "1978-1981", iconBackground: "bg-gray-400" },
  { id: 2, content: t('about.timeline2'), href: "#", date: "1990-1992", iconBackground: "bg-blue-500" },
  { id: 3, content: t('about.timeline3'), href: "#", date: "1998-2005", iconBackground: "bg-green-500" },
  { id: 4, content: t('about.timeline4'), href: "#", date: "2006-2010", iconBackground: "bg-blue-500" },
  { id: 5, content: t('about.timeline5'), href: "#", date: "2011-2020", iconBackground: "bg-green-500" },
];


const people = [
  {
    name: "Одод",
    bio: "Скандинавийн орнуудын барилга байгууламжийн хэв маягийг хадгалсан . Хадаас ороогүй оньсон чагтлах аргаар баригдсан .Учир нь уг орон маш чийглэг учраас хадаас зэв болж модоо идэн нурах аюултай учраас төмөрлөг зүйл бага ордог.",
    imageUrl: "/odod.png",
  },
  {
    name: "Солонго",
    imageUrl: "/solongo.png",
    bio: "Зүүн өмнөд ази буюу Вьетнам үндэсний барилгын хэв маягаар баригдсан. Социалист орнуудаас архитекторчид урьсны дагуу Вьетнам улс зураг төслөө илгээсэн. Барилга байшингууд нь ихэвчлэн усан дээр баригдсан байдгаас доороо урт модон тулгууртай байдаг.",
  },
  {
    name: "Сансар",
    imageUrl: "/sansar.png",
    bio: "Эртний Орос тосгоны байшин мэт сэтгэгдэл төрүүлэхээр баригдсан. Эртний Оросууд цонхны ойролцоо дээвэр, ханаа модоор янз бүрийн сийлбэр, хээ угалзуудын хамт хийн чамин маяг оруулдаг байсан. Мөн сүмийн маягтай цамхаг дээр нь зоосон тахиа үүнд хамаарна.",
  },
  {
    name: "Туяа",
    imageUrl: "/tuya.png",
    bio: "Болгар байшин нь нар тусах газар болгон буюу хана болгондоо нарны гэрэл тусгах, агаар оруулах зориулалттай цонх, дотор гаднагүй шавардлагатай байдгаараа онцлогтой билээ.",
  },
  {
    name: "Оч",
    imageUrl: "/och.png",
    bio: "Геометрийн дүрсүүд орсон хурц тод өнгө, 2 давхар баригдсан.",
  },
  {
    name: "Нарлаг",
    imageUrl: "/narlag.png",
    bio: "Монгол загварын байшин эртний сүм дуганы оройн ганжир, чөлөөт цагийн танхим нь Монгол гэр шиг дугуй хэлбэртэй хийгдсэн нь барилгын хийцтэй.",
  },
  {
    name: "Сэтгэмж",
    imageUrl: "/setgemj.png",
    bio: "Өмнө нь ОУХНЦ-н захиргаа, эмнэлэг үйл ажиллагаагаа явуулдаг байгаад Сэтгэмж бүлэг нэртэй болсон.",
  },
  {
    name: "Өвлийн амралтын төв байр",
    imageUrl: "/owliin.png",
    bio: "Өвлийн амралтын төв байр нь Ирээдүй, Мичид , Оргил, Сонор, Нөхөрлөл ,Ундраа гэсэн нийт 6 бүлэгтэй. Бүлгээсээ хамаарч 1 өрөөнд 4-10 хүүхэд амрах бөгөөд нийт 260 хүүхэд хүлээн авах хүчин чадалтай.",
  },
];

export default function About() {
  const { t } = useTranslation();
  const timeline = getTimeline(t);

  const features = [
    {
      name: t('about.mission'),
      description: t('about.missionDesc'),
      icon: CheckCircleIcon,
    },
    {
      name: t('about.values'),
      description: t('about.valuesDesc'),
      icon: StarIcon,
    },
    {
      name: t('about.vision'),
      description: t('about.visionDesc'),
      icon: EyeIcon,
    },
  ];

  const featuresContent = [
    {
      name: t('about.qualityPolicy'),
      description: t('about.qualityPolicyDesc'),
      href: "#",
      icon: ShieldCheckIcon,
    },
    {
      name: t('about.envPolicy'),
      description: t('about.envPolicyDesc'),
      href: "#",
      icon: SunIcon,
    },
  ];

  return (
    <>
      {/* ───────────────── Section 1 – Director Hero (Dark) ───────────────── */}
      <section className="relative overflow-hidden bg-primary-800 -mt-20">
        {/* 3 blur orbs */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute -bottom-20 right-1/3 w-[400px] h-[400px] rounded-full bg-primary-400/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="default" />
        {/* grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />

        <div className="relative min-h-screen pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
            {/* Badge pill */}
            <div className="flex justify-center mb-10 animate-fade-in">
              <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-primary-300 backdrop-blur-sm">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
                {t('about.directorTitle')}
              </div>
            </div>

            {/* Gradient heading */}
            <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight mb-14 animate-fade-in">
              <span className="bg-gradient-to-r from-primary-400 via-secondary-400 to-primary-300 bg-clip-text text-transparent">
                {t('about.directorGreeting')}
              </span>
            </h2>

            {/* 5-col grid: image 2 col, message 3 col */}
            <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 items-start animate-fade-in">
              {/* Image — 2 cols */}
              <div className="lg:col-span-2 text-center lg:text-left animate-slide-up">
                <div className="relative inline-block">
                  {/* Glow behind image */}
                  <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-secondary-500/20 to-primary-500/20 rounded-3xl blur-2xl" />
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10 group">
                    <img
                      className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                      src="/otgonbat.png"
                      alt="Ерөнхий захирал"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                </div>
                {/* Director name — gradient text */}
                <figcaption className="mt-6">
                  <div className="inline-block bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl px-6 py-4">
                    <div className="text-sm text-slate-400 mb-1">{t('about.directorTitle')}</div>
                    <div className="font-bold text-xl bg-gradient-to-r from-primary-400 via-secondary-400 to-primary-300 bg-clip-text text-transparent">
                      {t('about.directorName')}
                    </div>
                  </div>
                </figcaption>
              </div>

              {/* Message — 3 cols */}
              <div className="lg:col-span-3 animate-slide-up" style={{ animationDelay: '0.1s' }}>
                <div className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12">
                  <div className="space-y-6 text-slate-300 leading-relaxed text-base sm:text-lg">
                    <p>{t('about.directorP1')}</p>
                    <p>{t('about.directorP2')}</p>
                    <p>{t('about.directorP3')}</p>
                    {/* Last quote — border-left + italic */}
                    <p className="border-l-4 border-primary-400 pl-5 italic text-primary-300 font-medium">
                      {t('about.directorP4')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ───────────────── Section 2 – Introduction (White) ───────────────── */}
      <div className="relative bg-white py-16 sm:py-24 overflow-hidden">
        {/* Subtle background blobs */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-32 -left-32 w-[400px] h-[400px] rounded-full bg-primary-100/60 blur-[100px]" />
          <div className="absolute bottom-0 right-0 w-[350px] h-[350px] rounded-full bg-secondary-100/50 blur-[80px]" />
        </div>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            {/* Text column */}
            <div className="order-2 lg:order-1 animate-slide-up">
              {/* Badge pill */}
              <div className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-sm font-medium text-primary-700 ring-1 ring-primary-200/50 mb-6">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse" />
                {t('about.introTitle')}
              </div>

              <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-6">
                {t('about.introTitle')}
              </h2>
              <p className="text-lg leading-8 text-neutral-600 mb-10">
                {t('about.introDescription')}
              </p>

              {/* Feature cards — colored left border + bg-neutral-50 */}
              <dl className="space-y-5">
                {features.map((feature, index) => {
                  const borderColor = ['border-primary-500', 'border-secondary-500', 'border-warm-500'][index % 3];
                  return (
                    <div
                      key={feature.name}
                      className={`border-l-4 ${borderColor} bg-neutral-50 rounded-xl p-5 pl-6 hover:shadow-md transition-shadow duration-300`}
                      style={{ animationDelay: `${index * 0.1}s` }}
                    >
                      <dt className="font-bold text-lg text-neutral-900 mb-1 flex items-center gap-3">
                        <feature.icon className="h-5 w-5 text-neutral-500 flex-shrink-0" aria-hidden="true" />
                        {feature.name}
                      </dt>
                      <dd className="text-neutral-600 leading-relaxed">{feature.description}</dd>
                    </div>
                  );
                })}
              </dl>
            </div>

            {/* Image column */}
            <div className="order-1 lg:order-2 animate-scale-in">
              <div className="relative">
                {/* Glow behind image */}
                <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-secondary-500/20 to-primary-500/20 rounded-3xl blur-2xl" />
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                  <img
                    src="/nairamdal-image.jpg"
                    alt="Найрамдал цогцолбор"
                    className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                    width={2432}
                    height={1442}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ───────────────── Section 3 – Policies (Dark) ───────────────── */}
      <div className="relative overflow-hidden bg-primary-800">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="alt" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />

        <div className="relative py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {/* Heading with gradient underline bar */}
            <div className="text-center mb-14">
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                {t('about.policyTitle')}
              </h2>
              <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500" />
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              {featuresContent.map((feature, index) => {
                const iconGradient = ['from-secondary-500 to-secondary-600', 'from-warm-500 to-warm-600'][index % 2];
                const accentGradient = ['from-secondary-500 to-secondary-400', 'from-warm-500 to-warm-400'][index % 2];
                return (
                  <div
                    key={feature.name}
                    className="relative bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl md:p-10 p-8 hover:bg-white/[0.08] transform hover:-translate-y-2 transition-all duration-300 group animate-slide-up items-start"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    {/* Top accent gradient line on hover */}
                    <div className={`absolute top-0 left-8 right-8 h-px bg-gradient-to-r ${accentGradient} opacity-0 group-hover:opacity-100 transition-opacity`} />
                    <div className="flex items-start gap-4 mb-6">
                      <div className={`flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br ${iconGradient} shadow-md flex-shrink-0`}>
                        <feature.icon className="h-7 w-7 text-white" aria-hidden="true" />
                      </div>
                      <dt className="text-xl font-bold leading-7 text-white pt-3">
                        {feature.name}
                      </dt>
                    </div>
                    <dd className="text-base leading-7 text-slate-400">
                      <p>{feature.description}</p>
                    </dd>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* ───────────────── Section 4 – Timeline (White) ───────────────── */}
      <div className="bg-white py-16 sm:py-24 relative overflow-hidden">
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14 animate-fade-in">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-neutral-900 mb-4">
              {t('about.timelineTitle')}
            </h2>
            <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500" />
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Timeline with continuous vertical gradient line */}
            <div className="relative animate-slide-up">
              {/* Continuous vertical gradient line */}
              <div className="absolute left-[23px] top-6 bottom-6 w-0.5 bg-gradient-to-b from-primary-400 via-secondary-400 to-primary-300 rounded-full" />

              <div className="space-y-8">
                {timeline.map((event, eventIdx) => {
                  const dotColor = eventIdx % 2 === 0 ? 'bg-primary-500' : 'bg-secondary-500';
                  return (
                    <div
                      key={event.id}
                      className="relative pl-14"
                      style={{ animationDelay: `${eventIdx * 0.1}s` }}
                    >
                      {/* Timeline dot with ring */}
                      <div className={`absolute left-2.5 top-5 w-5 h-5 rounded-full ${dotColor} ring-4 ring-white shadow-md z-10`} />

                      <div className="border border-neutral-100 rounded-2xl p-6 hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 bg-white">
                        <p className="text-lg font-bold text-primary-600 mb-2">{event.date}</p>
                        <p className="text-neutral-600 leading-relaxed">{event.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Gallery — CSS columns-2 masonry */}
            <div className="hidden lg:block animate-scale-in">
              <div className="columns-2 gap-4 space-y-4">
                {['/Rectangle_37.png', '/Rectangle_38.png', '/Rectangle_39.png', '/Rectangle_41.png', '/Rectangle_42.png'].map((img, idx) => (
                  <div
                    key={idx}
                    className="break-inside-avoid rounded-2xl overflow-hidden shadow-md hover:shadow-lg transform hover:scale-[1.03] transition-all duration-300"
                    style={{ animationDelay: `${idx * 0.1}s` }}
                  >
                    <img
                      src={img}
                      alt=""
                      className="w-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ───────────────── Section 5 – Groups (Dark) ───────────────── */}
      <div className="relative overflow-hidden bg-primary-800">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-warm-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="sparse" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />

        <div className="relative py-16 sm:py-24">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14 animate-fade-in">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
                {t('about.groupsTitle')}
              </h2>
              <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500 mb-4" />
              <p className="mt-4 text-lg leading-8 text-slate-400 max-w-3xl mx-auto">
                {t('about.groupsDescription')}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {people.map((person, index) => {
                const accentGradient = [
                  'from-primary-500 to-primary-400',
                  'from-secondary-500 to-secondary-400',
                  'from-warm-500 to-warm-400',
                  'from-accent-500 to-accent-400',
                ][index % 4];
                return (
                  <div
                    key={person.name}
                    className="relative flex flex-col h-full bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl overflow-hidden hover:bg-white/[0.08] transform hover:-translate-y-2 transition-all duration-300 group animate-slide-up"
                    style={{ animationDelay: `${index * 0.08}s` }}
                  >
                    {/* Image with name overlay */}
                    <div className="relative overflow-hidden">
                      <img
                        className="aspect-[4/3] w-full object-cover group-hover:scale-110 transition-transform duration-500"
                        src={person.imageUrl}
                        alt={person.name}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0" />
                      <h3 className="absolute bottom-3 left-4 text-xl font-bold text-white drop-shadow-lg">
                        {person.name}
                      </h3>
                    </div>

                    {/* Body — flex-1 fills remaining space */}
                    <div className="p-6 flex-1 flex flex-col">
                      <p className="text-base leading-7 text-slate-400 line-clamp-4 flex-1">
                        {person.bio}
                      </p>
                    </div>

                    {/* Bottom accent gradient bar on hover */}
                    <div className={`h-1 bg-gradient-to-r ${accentGradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
